import { render, staticRenderFns } from "./FormFinalities.vue?vue&type=template&id=cbe3813c&scoped=true&"
import script from "./FormFinalities.vue?vue&type=script&lang=js&"
export * from "./FormFinalities.vue?vue&type=script&lang=js&"
import style0 from "./FormFinalities.vue?vue&type=style&index=0&id=cbe3813c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe3813c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextarea})
